import * as React from 'react';
import { cn } from '../../lib/utils';

/* v9 .h-tabs — flat horizontal tab strip with an underlined active state.
   Used at the top of the post-auth shell (Hearths / Higlos / Help / Account).

   Each tab item: { id, label, badge? (number for unread dot) } */
export function HTabs({ tabs, activeId, onChange, className }) {
  return (
    <div
      role="tablist"
      className={cn('flex gap-1 px-4 border-b border-slate-200', className)}
    >
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cn(
              'relative -mb-px py-2 px-3 text-[13px] border-b-2 transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:rounded-sm',
              active
                ? 'text-slate-900 font-semibold border-slate-900'
                : 'text-slate-500 font-medium border-transparent hover:text-slate-700',
            )}
          >
            {tab.label}
            {tab.badge ? (
              <span
                className="absolute top-1.5 right-1 w-[7px] h-[7px] rounded-full bg-red-500 ring-[1.5px] ring-white"
                aria-label={`${tab.badge} unread`}
              />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
